import { createBrowserRouter } from 'react-router-dom';
import ErrorPage from './ErrorPage';
import AuthPage from '../../layouts/authPage/AuthPage';
import SignInPage from './SignInPage';
import InviteRedirect from './InviteRedirect';

export const Router = createBrowserRouter([
  {
    element: <AuthPage />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'invite/accept/:inviteId',
        element: <InviteRedirect />
      },
      {
        path: '*',
        element: <SignInPage />
      }
    ]
  }
]);
